export default __webpack_public_path__ + "static/media/Martiyers6.005d03be.jpg";